export default __webpack_public_path__ + "static/media/linkedin-light.c4b6e21e.svg";